import {ArtAndFoodView} from "./art-and-food.view";
export default ArtAndFoodView;
